/**
 * New Title Levels
 */
export var TitleLevels;
(function (TitleLevels) {
    TitleLevels["ONE"] = "ONE";
    TitleLevels["TWO"] = "TWO";
    TitleLevels["THREE"] = "THREE";
})(TitleLevels || (TitleLevels = {}));
export var TitleMarkup;
(function (TitleMarkup) {
    TitleMarkup["H1"] = "h1";
    TitleMarkup["H2"] = "h2";
    TitleMarkup["H3"] = "h3";
    TitleMarkup["H4"] = "h4";
    TitleMarkup["H5"] = "h5";
    TitleMarkup["H6"] = "h6";
    TitleMarkup["P"] = "p";
    TitleMarkup["SPAN"] = "span";
    TitleMarkup["DIV"] = "div";
})(TitleMarkup || (TitleMarkup = {}));
//# sourceMappingURL=TitleEnum.js.map